import { useState } from "react";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import {
  useCustomerFtth,
  useFtthGroupListHooks,
  useReportCustomerFtth,
} from "../../utils/customer/CustomerReqReprotUtil";
import Pagination from "../../components/Pagination";
import { Modal } from "react-bootstrap";

export default function ReportCustomerFtth() {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const [formFilter, setFormFilter] = useState({ project: "", year: "2024" });
  const [filter, setFilter] = useState({ project: "", year: "2024", page: 1, page_size: 30 });

  const { projects: groups } = useFtthGroupListHooks();
  const { customers, meta, loading, errorMsg } = useReportCustomerFtth({ filter });

  const [modal, setModal] = useState("");
  const [selected, setSelected] = useState(null);

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({ project: "", year: "2024" });
    setFilter({ project: "", year: "2024", page: 1, page_size: 30 });
  };
  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <h1 className="h3 mb-4 text-gray-800">Laporan Pelanggan FTTH</h1>
        <Box title={`Pelanggan FTTH`} loading={loading}>
          <div className="row">
            <div className="col-12 col-md-2">
              <div className="form-group">
                <label>Project</label>
                <select
                  className="form-control"
                  id="projectFilter"
                  value={formFilter.project}
                  onChange={(event) =>
                    setFormFilter({ ...formFilter, project: event.target.value })
                  }
                >
                  <option value="">SEMUA</option>
                  {groups.map((project, index) => (
                    <option value={project.id} key={index}>
                      {project.project}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-auto">
              <button
                className="btn btn-primary"
                onClick={() => applyFilter()}
                style={{ marginTop: "32px" }}
              >
                Filter
              </button>
              <button
                className="btn btn-default"
                onClick={() => resetFilter()}
                style={{ marginTop: "32px" }}
              >
                Reset
              </button>
            </div>
          </div>
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="row">
            <div className="col-12">
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th>No. Registrasi</th>
                      <th>Project</th>
                      <th>Paket</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.map((customer, index) => (
                      <tr key={index}>
                        <td style={{ width: "60px" }}>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                              setSelected(customer.registration_number);
                              setModal("detail");
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </button>
                        </td>
                        <td>{customer.registration_number}</td>
                        <td>{customer.project}</td>
                        <td>{customer.internet_package}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {meta.count > meta.page_size && (
                  <Pagination
                    totalpage={Math.ceil(meta.count / meta.page_size)}
                    selectedpage={meta.page}
                    clickpage={(page) => gotoPage(page)}
                    next={() => gotoPage(meta.page + 1)}
                    prev={() => gotoPage(meta.page - 1)}
                  />
                )}
              </div>
            </div>
          </div>
        </Box>
      </div>

      <ModalCustomer
        show={modal === "detail"}
        selected={selected}
        filter={filter}
        onClose={() => setModal("")}
      />
    </MainLayout>
  );
}

function ModalCustomer({ selected, show, filter, onClose }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Detail Pelanggan FTTH</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ModalBodyCustomer id={selected} filter={filter} />
      </Modal.Body>
    </Modal>
  );
}
function ModalBodyCustomer({ id, filter }) {
  const { data } = useCustomerFtth({ id, filter });

  return (
    <table className="table table-bordered">
      <tbody>
        <tr>
          <td width="200">Nomor Registrasi</td>
          <td>{data?.registration_number}</td>
        </tr>
        <tr>
          <td>Nama</td>
          <td>{data?.name}</td>
        </tr>
        <tr>
          <td>Alamat</td>
          <td>{data?.installation_address?.address}</td>
        </tr>
        <tr>
          <td>RT</td>
          <td>{data?.installation_address?.rt}</td>
        </tr>
        <tr>
          <td>RW</td>
          <td>{data?.installation_address?.rw}</td>
        </tr>
        <tr>
          <td>Provinsi</td>
          <td>{data?.installation_address?.addresses?.province}</td>
        </tr>
        <tr>
          <td>Kota/Kabupaten</td>
          <td>{data?.installation_address?.addresses?.kota_kab}</td>
        </tr>
        <tr>
          <td>Kecamatan</td>
          <td>{data?.installation_address?.addresses?.kecamatan}</td>
        </tr>
        <tr>
          <td>Kelurahan</td>
          <td>{data?.installation_address?.addresses?.kelurahan}</td>
        </tr>
        <tr>
          <td>Kode Pos</td>
          <td>{data?.installation_address?.addresses?.postal_code}</td>
        </tr>
      </tbody>
    </table>
  );
}
